import { ConfirmationModal } from '@library/components/modals/ConfirmationModal';
import type { RemovalWarningType } from '@bo-hooks/playerModal/useRemovalWarnings';

export function ConfirmRemoveProjectionsModal({
  removalWarnings,
  handleCancelRemoval,
  handleConfirmRemoval
}: {
  removalWarnings: Record<RemovalWarningType, number> | undefined;
  handleCancelRemoval: () => void;
  handleConfirmRemoval: () => void;
}) {
  return (
    <ConfirmationModal
      isOpen={!!removalWarnings}
      confirmationCopy="Confirm"
      onCancelModal={handleCancelRemoval}
      handleConfirm={handleConfirmRemoval}
      label="Confirm Remove Projections"
    >
      <p className="text-soFresh-190">
        You are about to remove the following projections. Are you sure?
      </p>
      <ul className="list-disc">
        {removalWarnings &&
          Object.entries(removalWarnings).map(([type, amount]) => (
            <li key={type} className="ml-8">
              {type}: {amount}
            </li>
          ))}
      </ul>
    </ConfirmationModal>
  );
}
